import React from 'react';
const NotFound: React.FC = () => <h1>Not Found</h1>;

export default NotFound;
